export enum AuthenticationKind {
  ANONYMOUS,
  AUTHENTICATED,
}
